import hartchart from "./components/tools/ToolHartChart.vue";
import trackletters from "./components/tools/ToolTrackLetters.vue";
import racetracks from "./components/tools/ToolRacetracks.vue";
import metronome from "./components/tools/ToolMetronome.vue";

export default {
  hartchart,
  trackletters,
  racetracks,
  metronome
};
